import { useFlagConfigValue } from 'hooks/business/system/useFlagConfig';
import { Tooltip } from 'antd';
import styled from '@emotion/styled';
import { useTranslate } from '@tolgee/react';
import IdPng from '../../assets/id.png';

export const Help = () => {
  const { payQrcode } = useFlagConfigValue();
  const { t } = useTranslate();

  return (
    <Tooltip
      overlayStyle={{ maxWidth: '210px' }}
      color="white"
      trigger="hover"
      title={() => (
        <HelpContainer>
          <div>
            {t('market.若在使用/购买过程中遇到问题或其他需求')}
            <br />
            {t('market.可随时扫码联系我们的客户服务专家')}
          </div>
          <img src={payQrcode} alt="qrcode" />
        </HelpContainer>
      )}
    >
      <span className="cursor-help text-[--ant-primary-color]">{t('header.联系我们')}</span>
    </Tooltip>
  );
};

export const CompanyAliHelp = () => {
  const { t } = useTranslate();
  return (
    <Tooltip
      color="white"
      overlayStyle={{ maxWidth: '394px' }}
      title={() => (
        <div>
          <div className="leading-[20px] text-[#515359]">{t('aiorder_ali_company_tip')}</div>
          <div className="px-[8px] mt-[12px]">
            <img className="w-full h-auto" src={IdPng} alt="id" />
          </div>
        </div>
      )}
    >
      <span className="cursor-help text-[--ant-primary-color]">{t('aiorder_check_alipay')}</span>
    </Tooltip>
  );
};

const HelpContainer = styled.div`
  padding: 8px;
  color: #232426;

  > * {
    margin-bottom: 16px;
  }
  > h3 {
    font-size: 16px;
    color: #232426;
  }
  > img {
    width: 160px;
    height: 160px;
    margin: 0 auto;
    display: block;
  }
`;
